function normalizeUidKey(uid) {
  if (uid === null || uid === undefined || uid === '') {
    return ''
  }

  const numericUid = Number(uid)

  if (Number.isFinite(numericUid)) {
    return String(numericUid)
  }

  const trimmedUid = String(uid).trim()

  return trimmedUid
}

function matchesUid(leftValue, rightValue) {
  const leftUid = normalizeUidKey(leftValue)
  const rightUid = normalizeUidKey(rightValue)

  return Boolean(leftUid) && leftUid === rightUid
}

function createRemoteUserEntry(uid, previousEntry = {}, screenshareUid = null) {
  return {
    uid,
    audioTrack: previousEntry.audioTrack || null,
    videoTrack: previousEntry.videoTrack || null,
    hasAudio: previousEntry.hasAudio || false,
    hasVideo: previousEntry.hasVideo || false,
    isScreenShare:
      previousEntry.isScreenShare || matchesUid(uid, screenshareUid),
    lastActivityAt: previousEntry.lastActivityAt || 0,
  }
}

export const AGORA_REMOTE_PARTICIPANT_EVENT_TYPES = Object.freeze({
  joined: 'joined',
  left: 'left',
  published: 'published',
  unpublished: 'unpublished',
})

export function reduceAgoraRemoteParticipants(previousState = {}, event = {}) {
  const uidKey = normalizeUidKey(event?.uid ?? event?.user?.uid)

  if (!uidKey) {
    return previousState
  }

  const existingEntry = previousState[uidKey] || null

  if (
    event?.type === AGORA_REMOTE_PARTICIPANT_EVENT_TYPES.left &&
    !existingEntry
  ) {
    return previousState
  }

  if (
    event?.type !== AGORA_REMOTE_PARTICIPANT_EVENT_TYPES.left &&
    !existingEntry &&
    event?.uid === undefined &&
    event?.user?.uid === undefined
  ) {
    return previousState
  }

  const nextState = { ...previousState }
  const entryUid = event?.uid ?? event?.user?.uid
  const nextEntry = createRemoteUserEntry(entryUid, existingEntry || {}, event?.screenshareUid)

  switch (event?.type) {
    case AGORA_REMOTE_PARTICIPANT_EVENT_TYPES.joined:
      nextState[uidKey] = {
        ...nextEntry,
        hasAudio: Boolean(event?.user?.audioTrack ?? nextEntry.audioTrack),
        hasVideo: Boolean(event?.user?.videoTrack ?? nextEntry.videoTrack),
        lastActivityAt: event?.occurredAt || Date.now(),
      }
      return nextState
    case AGORA_REMOTE_PARTICIPANT_EVENT_TYPES.left:
      delete nextState[uidKey]
      return nextState
    case AGORA_REMOTE_PARTICIPANT_EVENT_TYPES.published:
      nextState[uidKey] = {
        ...nextEntry,
        audioTrack:
          event?.mediaType === 'audio'
            ? event?.user?.audioTrack || null
            : nextEntry.audioTrack,
        videoTrack:
          event?.mediaType === 'video'
            ? event?.user?.videoTrack || null
            : nextEntry.videoTrack,
        hasAudio: event?.mediaType === 'audio' ? true : nextEntry.hasAudio,
        hasVideo: event?.mediaType === 'video' ? true : nextEntry.hasVideo,
        isScreenShare: matchesUid(entryUid, event?.screenshareUid),
        lastActivityAt: event?.occurredAt || Date.now(),
      }
      return nextState
    case AGORA_REMOTE_PARTICIPANT_EVENT_TYPES.unpublished:
      nextState[uidKey] = {
        ...nextEntry,
        audioTrack:
          event?.mediaType === 'audio' ? null : nextEntry.audioTrack,
        videoTrack:
          event?.mediaType === 'video' ? null : nextEntry.videoTrack,
        hasAudio: event?.mediaType === 'audio' ? false : nextEntry.hasAudio,
        hasVideo: event?.mediaType === 'video' ? false : nextEntry.hasVideo,
        isScreenShare: matchesUid(entryUid, event?.screenshareUid),
        lastActivityAt: event?.occurredAt || Date.now(),
      }
      return nextState
    default:
      return previousState
  }
}
